<template>
	<div
		class="rounded-lg sm:rounded-xl p-4 lg:p-4 shadow bg-white grid grid-cols-5"
	>
		<div class="text-gray-700 text-4xl font-semibold">
			F-Weizen<br />
			2021
		</div>
		<div
			class="col-span-4"
			ref="chart"
			style="width: 100%; height: 400px"
		></div>
	</div>
</template>

<script>
import { groupBy, sum, min, max, mean, range } from "lodash";
import * as echarts from "echarts";

export default {
	props: {
		data: {
			type: Array,
			required: true,
		},
		contracts: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			myChart: null,
			// colors: ['#5470C6', '#EE6666']
		};
	},
	methods: {},
	mounted() {
		console.log(
			this.contracts.map(function (i) {
				return [i["date"], i["price"], i["price"]];
			})
		);
		let chartDom = this.$refs.chart,
			contractDates = this.contracts.map(function (i) {
				return [i["date"], i["price"], i["qty__mt"], i["counterpart"]];
			}),
			dataX = this.data.map((i) => i.date),
			dataY = this.data.map((i) => i.price),
			// dataY1 =this.data.map(i => i['Dez 2020 MATIF-Weizen (Nr. 2)']),
			// dataY2 =this.data.map(i => i['Mar 2021 MATIF-Weizen (Nr. 2)']),
			// dataY3 =this.data.map(i => i['Mai 2021 MATIF-Weizen (Nr. 2)']),
			// dataY4 =this.data.map(i => i['Sep 2021 MATIF-Weizen (Nr. 2)']),
			option = {
				legend: {
					right: 0,
					textStyle: {
						color: "#757575",
					},
					selectedMode: false,

					// data: [
					//     {name: '1', icon: 'circle'},
					//     {name: '2', icon: 'line'}
					// ]
				},
				dataset: {
					source: [
						["product"].concat(dataX),
						["Matif"].concat(dataY),
						// ["Dez 2020"].concat(dataY1),
						// ["Mar 2021"].concat(dataY2),
						// ["Mai 2021"].concat(dataY3),
						// ["Sep 2021"].concat(dataY3),
					],
				},
				xAxis: {
					type: "time",
					min: "2020-12-12",
					axisLine: {
						show: true,
						lineStyle: {
							color: "#DFDFDE",
						},
					},
					axisLabel: {
						show: true,
						textStyle: {
							color: "#757575",
						},
						formatter: "{MMM} {yy}",
					},
					splitLine: {
						show: true,
						lineStyle: {
							color: "#EBEBEA",
						},
					},
				},
				yAxis: {
					type: "value",
					axisLine: {
						show: true,
						lineStyle: {
							color: "#DFDFDE",
						},
					},
					axisLabel: {
						show: true,
						textStyle: {
							color: "#757575",
						},
					},
				},
				grid: {
					show: true,
					top: "31px",
					left: "5%",
					right: "0",
					bottom: "5%",
					containLabel: true,
				},
				series: [
					{
						type: "line",
						showSymbol: false,
						smooth: true,
						seriesLayoutBy: "row",
						// emphasis: { focus: "series" },
						itemStyle: {
							color: "#C4C4C4",
						},
					},
					{
						name: __("Price for contracts"),
						symbolSize: 10,
						data: contractDates,
						type: "scatter",
						// yAxisIndex: 1,
						itemStyle: {
							color: "#F19300",
						},
						tooltip: {
							show: true,
						},
					},
				],
				textStyle: {
					fontFamily: "Barlow, Roboto, Helvetica, Arial, sans-serif",
					fontSize: "14",
					fontWeight: "500",
				},
				tooltip: {
					trigger: "item",
					backgroundColor: "#454545",
					borderColor: "#454545",
					textStyle: {
						color: "#F6F6F4",
					},
					// formatter: 'my custom text and {a}, {b}, {c} and {d}'
					// 300 t für 205 €/t Carlo GbR
					// 2. Aug 21
					// ['date' => "2021-03-28", 'price' => 234.45, 'qty__mt' => '100', 'counterpart' => 'B.v. Marderstedt']
					formatter: function (params) {
						return `${params.data[2]} t für ${params.data[1]} €/t<br />
                            ${params.data[3]}<br />
                            ${params.data[0]}`;
					},
				},
			};

		this.myChart = echarts.init(chartDom);
		this.myChart.setOption(option);
		let that = this;
	},
	computed: {},
};
</script>
